module.exports = __webpack_public_path__ + "img/info.6f275ea3.svg";